import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import { type MutableRefObject, useEffect, useRef } from 'react';
import { ASK_PERCY_ROUTE, CHAT_SESSION_ROUTE } from '@/config/constants';
type UseResetChatOnTenantSwitchArgs = {
  orgId?: string;
  sessionId: string | null;
  setSessionId: (id: string | null) => void;
  restoredRef: MutableRefObject<boolean>;
  mintingRef: MutableRefObject<boolean>;
  routeChatTenantId?: string;
};

/**
 * A tenant switch doesn't remount the chat widget, so the session would keep the prior tenant's
 * chat. That stale id 404s and the chat error path auto-assumes its owning tenant — switching the
 * user back. On an org change, clear it and re-arm the restore; on `/chat/{id}` the URL would
 * re-seed the id, so redirect to `/ask-percy`. A switch into the route chat's own tenant is that
 * chat's assume landing, so it changes nothing.
 */
const useResetChatOnTenantSwitch = t0 => {
  const $ = _c(13);
  const {
    orgId,
    sessionId,
    setSessionId,
    restoredRef,
    mintingRef,
    routeChatTenantId
  } = t0;
  const router = useRouter();
  const prevOrgIdRef = useRef(undefined);
  let t1;
  if ($[0] !== mintingRef || $[1] !== orgId || $[2] !== restoredRef || $[3] !== routeChatTenantId || $[4] !== router || $[5] !== sessionId || $[6] !== setSessionId) {
    t1 = () => {
      if (!orgId) {
        return;
      }
      if (prevOrgIdRef.current === undefined) {
        prevOrgIdRef.current = orgId;
        return;
      }
      if (prevOrgIdRef.current === orgId) {
        return;
      }
      prevOrgIdRef.current = orgId;
      if (orgId === routeChatTenantId) {
        return;
      }
      restoredRef.current = false;
      if (sessionId !== null) {
        setSessionId(null);
      }
      if (router.pathname === CHAT_SESSION_ROUTE) {
        mintingRef.current = true;
        router.replace(ASK_PERCY_ROUTE).finally(() => {
          mintingRef.current = false;
        });
      }
    };
    $[0] = mintingRef;
    $[1] = orgId;
    $[2] = restoredRef;
    $[3] = routeChatTenantId;
    $[4] = router;
    $[5] = sessionId;
    $[6] = setSessionId;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== orgId || $[9] !== routeChatTenantId || $[10] !== router.pathname || $[11] !== sessionId) {
    t2 = [orgId, sessionId, router.pathname, routeChatTenantId];
    $[8] = orgId;
    $[9] = routeChatTenantId;
    $[10] = router.pathname;
    $[11] = sessionId;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  useEffect(t1, t2);
};
export default useResetChatOnTenantSwitch;